module.exports = __webpack_public_path__ + "static/media/littlebeet-spotlight-icon.d5fe99ed.png";